import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState, AppDispatch } from "./redux-store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
}>();
